<template>
  <v-container class="fill-height mt-2">
    Отчёт по расчёту
  </v-container>
</template>

<script>
export default {
  name: 'rcptReportPanel',
  mixins: [],
  props: {
    receipt: {
      type: Object,
      default: function () {
        return {}
      }
    },
    activeTab: {
      type: String,
      default: null
    }
  },
  emits: ['onChange'],
  components: { },
  data () {
    return {}
  },
  computed: {},
  watch: {
    activeTab (val) {
      console.log('rcptReportPanel activeTab changed to ', val)
    }
  },
  methods: {
    onChangeReceipt (val) {
      this.$emit('onChange', val)
    }
  },
  mounted () {
    console.log('rcptReportPanel mounted with receipt ', this.receipt)
  }
}
</script>
